import { FeatureFlags, SEVERITY_LABELS, SeverityLabels } from '@fabric-ui/components';
import { entityProjectionNames } from '@utils/entityProjectionNames';
import { useAvContext } from '../../../../context/AvContextProvider';
import { useGetSeveritySettings } from './hooks';
import { getSeverityByScoreV2, getSeverityRows } from './utils';

export const useSeverity = (projectionName: string = entityProjectionNames.Ticket) => {
  const { featureFlags } = useAvContext();
  const isNewRiskScoreEnabled = featureFlags[FeatureFlags.NewRiskScore];
  const { data: settingsSeverities, isLoading } = useGetSeveritySettings();

  const getSeverity = (score: number) => {
    if (!settingsSeverities?.automationRules) return null;
    const rows = getSeverityRows({ projectionName, rules: settingsSeverities.automationRules, isNewRiskScoreEnabled });
    return getSeverityByScoreV2(rows, score);
  };

  const getSeverityName = (severity: SeverityLabels) => `${SEVERITY_LABELS[severity]} Risk`;

  return {
    getSeverity,
    getSeverityName,
    isLoading,
    severities: settingsSeverities,
  };
};
